module.exports = __webpack_public_path__ + "img/21_14.7fce2ac5.png";